module.exports = __webpack_public_path__ + "5c62f9aca3f5647e776981a3012becc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icon/folder.svg
// module id = 2002
// module chunks = 0